<template>
  <div class="login-box">
    <img class="login-logo" :src="$store.state.tenantConfig?.loginLogoUrl || $store.state.tenantConfig?.logoUrl" alt="Logo" v-if="$store.state.tenantConfig?.loginLogoUrl || $store.state.tenantConfig?.logoUrl" />
    <h2 class="login-title" v-else>{{ $store.state.tenantConfig?.name || 'Screenmanagement' }}</h2>
    <form id="loginForm" class="login-form" @submit.prevent="formSubmit" v-if="currentPage==='loginForm'">
      <TextInput name="user" placeholder="Benutzername" />
      <TextInput name="password" placeholder="Passwort" type="password" />
      <p v-if="error" style="color:var(--error);">Benutzername oder Passwort falsch!</p>
      <PrimaryButton :full-width="true" text="Anmelden" />
    </form>
    <PasswordReset v-if="currentPage==='resetForm'" />
    <PasswordResetEmail v-if="currentPage==='sendEmailForm'" />
    <router-link to="/passwordReset" class="password-reset-link" v-if="currentPage==='loginForm'">
      Passwort vergessen?
    </router-link>
    <router-link to="/" class="password-reset-link" v-else>
      Zurück zum Login
    </router-link>
  </div>
</template>

<style>
a.password-reset-link {
  text-align: center;
}
</style>

<script>
import TextInput from "@/components/elements/TextInput.vue";
import PrimaryButton from "@/components/elements/PrimaryButton.vue";
import PasswordReset from "@/components/views/login/passwordReset.vue";
import PasswordResetEmail from "@/components/views/login/passwordResetEmail.vue";

export default {
  data() {
    return {
      currentPath: window.location.pathname,
      error: false,
    };
  },
  components: {
    PrimaryButton,
    TextInput,
    PasswordReset,
    PasswordResetEmail,
  },
  computed: {
    currentPage() {
      const path = this.currentPath;

      if(path.includes("/passwordReset")) {
        const parts = path.split("/").filter(Boolean);
        const index = parts.indexOf("passwordReset");

        if(index !== -1 && parts.length > index + 1) {
          return "resetForm";
        }
        return "sendEmailForm";
      }

      return "loginForm";
    }
  },
  methods: {
    async formSubmit() {
      const data = this.getFormData('loginForm');
      let res = await this.apiRequest('POST', '/account/login', data, false);
      if(res.success) {
        this.setSession(res.token);
      } else {
        this.error = true;
      }
    },
    updatePath() {
      this.currentPath = window.location.pathname;
    },
    patchHistoryMethods() {
      const methods = ["pushState", "replaceState"];
      methods.forEach(method => {
        const original = history[method];
        const self = this;
        history[method] = function() {
          const result = original.apply(this, arguments);
          self.updatePath();
          return result;
        };
      });
    }
  },
  mounted() {
    this.$store.commit("setPageTitle", "Login");
    this.setBreadCrumbs([]);

    this.patchHistoryMethods();
    window.addEventListener("popstate", this.updatePath);
  },
  beforeDestroy() {
    window.removeEventListener("popstate", this.updatePath);
  }
}
</script>